var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgTargetArrow = function SvgTargetArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13734_765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.334 12.0874C11.334 12.3526 11.4393 12.607 11.6269 12.7945C11.8144 12.9821 12.0688 13.0874 12.334 13.0874C12.5992 13.0874 12.8536 12.9821 13.0411 12.7945C13.2286 12.607 13.334 12.3526 13.334 12.0874C13.334 11.8222 13.2286 11.5679 13.0411 11.3803C12.8536 11.1928 12.5992 11.0874 12.334 11.0874C12.0688 11.0874 11.8144 11.1928 11.6269 11.3803C11.4393 11.5679 11.334 11.8222 11.334 12.0874Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.334 7.08743C11.3451 7.08743 10.3784 7.38068 9.55614 7.93008C8.73389 8.47949 8.09303 9.26039 7.71459 10.174C7.33615 11.0876 7.23713 12.093 7.43006 13.0629C7.62299 14.0328 8.09919 14.9237 8.79845 15.623C9.49772 16.3222 10.3886 16.7984 11.3585 16.9914C12.3284 17.1843 13.3338 17.0853 14.2474 16.7068C15.161 16.3284 15.9419 15.6875 16.4913 14.8653C17.0407 14.043 17.334 13.0763 17.334 12.0874",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 3.14244C11.4795 2.93445 9.6068 3.30772 7.97428 4.21061C6.34177 5.1135 5.03017 6.50139 4.22092 8.1823C3.41168 9.8632 3.14478 11.754 3.45714 13.5933C3.76951 15.4325 4.6457 17.1292 5.96452 18.4487C7.28334 19.7682 8.97961 20.6452 10.8187 20.9585C12.6577 21.2718 14.5487 21.0059 16.23 20.1975C17.9113 19.3891 19.2999 18.0782 20.2036 16.4461C21.1073 14.814 21.4815 12.9415 21.2745 11.0874",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.334 6.08743V9.08743H18.334L21.334 6.08743H18.334V3.08743L15.334 6.08743Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.334 9.08743L12.334 12.0874",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgTargetArrow);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/target-arrow.aa4170557b9e5e249f7939b70c4f9660.svg";